import * as React from 'react';

import { Typography, Radio, RadioGroup, TextField, Checkbox, FormControl, FormControlLabel, InputLabel, FormGroup, Grid, Box, Button, MenuItem, Select } from '@mui/material';

function createData(
  name: string,
  calories: number,
  fat: number,
  carbs: number,
  protein: number,
) {
  return { name, calories, fat, carbs, protein };
}

const rows = [
  createData('Frozen yoghurt', 159, 6.0, 24, 4.0),
  createData('Ice cream sandwich', 237, 9.0, 37, 4.3),
  createData('Eclair', 262, 16.0, 24, 6.0),
  createData('Cupcake', 305, 3.7, 67, 4.3),
  createData('Gingerbread', 356, 16.0, 49, 3.9),
];

function createRow(title: string, initialValue: string, value: string[]) {
  return (
    <Grid container spacing={1}>
      <Grid container item xs={1.5}>
        {title}
      </Grid>
      <Grid container item xs={1}>
        <FormControl size="small">
          <Select
            labelId="demo-simple-select-standard-label"
            id="demo-simple-select-standard"
            value={initialValue}
            sx={{ marginTop: -1 }}
          >
            {value.map(v => 
              <MenuItem value={v}>{v}</MenuItem>
            )}
          </Select>
        </FormControl>
      </Grid>
      <Grid container item xs={0.7}>
        <Button variant="contained" disabled sx={{ marginTop: -1 }}>取得</Button>
      </Grid>
      <Grid container item xs={0.7}>
        <Button variant="contained" disabled sx={{ marginTop: -1 }}>設定</Button>
      </Grid>
    </Grid>
  );
}

function dacBox(no: number) {
  return (
    <Box sx={{ flexGrow: 1, border: 1, borderRadius: 1 }} component={"fieldset"}>
      <legend>DAC{no}</legend>
      <Grid container spacing={2}>
            <Grid item xs={3.5}>
              <Typography gutterBottom sx={{ marginTop: 1 }}>Inputレジスタ</Typography>
            </Grid>
            <Grid item xs={0.6}>
              <Typography gutterBottom sx={{ marginTop: 1 }}>0x</Typography>
            </Grid>
            <Grid item xs={3}>
              <FormControl>
                <Select
                  labelId="demo-simple-select-standard-label"
                  id="demo-simple-select-standard"
                  value={'0000'}
                  size="small"
                >
                  <MenuItem value={'0000'}>0000</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={1.8}>
              <Button variant="contained" disabled>取得</Button>
            </Grid>
            <Grid item xs={1.8}>
              <Button variant="contained" disabled>設定</Button>
            </Grid>

        <Grid container item spacing={3}>
          <React.Fragment>
            <Grid item xs={12}>
              <Box sx={{ flexGrow: 1, border: 1, borderRadius: 1 }} component={"fieldset"}>
                <legend>Ctrlレジスタ</legend>
                <Grid>
                <FormControlLabel control={<Checkbox />} label="リセット" />
                <FormControlLabel control={<Checkbox />} label="ゲイン×2" />
                <Button variant="contained" disabled>設定</Button>
                </Grid>
                <Grid>
                <FormControlLabel control={<Checkbox />} label="内蔵リファレンスDisable" />
                </Grid>
                <Grid>
                <FormControl size="small">
                <InputLabel shrink htmlFor="select-multiple-native">
                  動作モード
               </InputLabel>
                <Select
                  labelId="demo-simple-select-standard-label"
                  id="demo-simple-select-standard"
                  value={'Normal'}
                  label="動作モード"
                  size="small"
                >
                  <MenuItem value={'Normal'}>Normal</MenuItem>
                </Select>
                </FormControl>
                </Grid>
              </Box>
            </Grid>
          </React.Fragment>
        </Grid>
      </Grid>
    </Box>
  )
}

function MeasSelect() {
  const [meas, setMeas] = React.useState("single-ended-single");


  const measChannel = () => {
    const channels = meas.includes('single-ended-') ? [ "CH1+", "CH1-", "CH2+", "CH2-" ] : [ "CH1", "CH2" ];       

    if (meas.includes('-single')) {
      return (
        <FormControl size="small">
          <Select
            labelId="demo-simple-select-standard-label"
            id="demo-simple-select-standard"
            defaultValue={channels[0]}
            value={channels[0]}
            style= {{ maxWidth: "120px" }}
            >
            {channels.map(v => <MenuItem value={v}>{v}</MenuItem>)}
          </Select>
        </FormControl>
      );
    } else if (meas.includes('-scan')) {
      return (
        <FormGroup row>
          {channels.map(v => <FormControlLabel control={<Checkbox />} label={v} />)}
        </FormGroup>
      );
    } else {
      return (
        <div />
      );
    }
  };

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setMeas((event.target as HTMLInputElement).value);
  };

  return (
      <Box sx={{ display: 'flex', flexDirection: 'row' }}>
      <Box>
    <Box sx={{ flexGrow: 1, border: 1, borderRadius: 1, minWidth: "750px" }} component={"fieldset"}>
      <legend>測定</legend>
      <Grid container spacing={1}>
        <Grid container item>
      <RadioGroup
        aria-labelledby="demo-controlled-radio-buttons-group"
        name="controlled-radio-buttons-group"
        defaultValue={"single-ended-single"}
        row
        onChange={handleChange}
      >
        <FormControlLabel value="single-ended-single" control={<Radio />} label="シングルエンド (Single)" />
        <FormControlLabel value="diff-single" control={<Radio />} label="差動 (Single)" />
        <FormControlLabel value="single-ended-scan" control={<Radio />} label="シングルエンド (Scan)" />
        <FormControlLabel value="diff-scan" control={<Radio />} label="差動 (Scan)" />
      </RadioGroup>
      </Grid>
      <Grid container item>
      {measChannel()}
      </Grid>
    </Grid>
    </Box>
    </Box>
    <Box sx={{ margin: 2 }}>
          <Button variant="contained" disabled>実行</Button>
          </Box>
          </Box>

  );
}

function adcBox() {
  return (
    <Box sx={{ flexGrow: 1, border: 1, borderRadius: 1, direction: "row" }} component={"fieldset"}>
      <legend>ADC</legend>

      <Box sx={{ flexGrow: 1, border: 1, borderRadius: 1 }} component={"fieldset"}>
        <legend>測定設定</legend>
        <Grid container item spacing={2}>
          <Grid item>
            <FormControl size="small">
              <InputLabel shrink htmlFor="select-multiple-native">
              </InputLabel>
              <Select
                labelId="demo-simple-select-standard-label"
                id="demo-simple-select-standard"
                value={'Normal'}
                label=""
              >
                <MenuItem value={'Normal'}>9MHz (ZG3)</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item>
            <FormControl size="small">
              <InputLabel shrink htmlFor="select-multiple-native">
                ACQサイクル
              </InputLabel>
              <Select
                labelId="demo-simple-select-standard-label"
                id="demo-simple-select-standard"
                value={'Normal'}
                label="ACQサイクル"
              >
                <MenuItem value={'Normal'}>2Cycle (ZG3)</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item>
            <FormControl size="small">
              <InputLabel shrink htmlFor="select-multiple-native">
                基準電圧
              </InputLabel>
              <Select
                labelId="demo-simple-select-standard-label"
                id="demo-simple-select-standard"
                value={'Normal'}
                label="基準電圧"
              >
                <MenuItem value={'Normal'}>Internal 1.25V</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item width={"180px"}>
            <TextField size="small" type="number" id="outlined-basic" label="サンプリング周期[ms]" variant="outlined" value={5} />
          </Grid>
          <Grid item width={"160px"}>
            <TextField size="small" type="number" id="outlined-basic" label="サンプリング回数" variant="outlined" value={1} />
          </Grid>
          <Grid item width={"180px"}>
            <FormControl size="small">
              <InputLabel shrink htmlFor="select-multiple-native">
                オーバーサンプリング
              </InputLabel>
              <Select
                labelId="demo-simple-select-standard-label"
                id="demo-simple-select-standard"
                value={'Normal'}
                label="オーバーサンプリング"
                fullWidth
              >
                <MenuItem value={'Normal'}>×1　　　　　　</MenuItem>
              </Select>
            </FormControl>
          </Grid>
        </Grid>
      </Box>
      <MeasSelect />
    </Box>
  );
}

export default function NestedGrid() {
  return (
    <Box sx={{  }}>
      <Grid container spacing={2}>
        <Grid container item>{createRow("動作ブロック", "なし", ["なし", "あり"])}</Grid>
        <Grid container item>{createRow("基板電源", "OFF", ["OFF", "ON"])}</Grid>
        <Grid container item>{createRow("センサ電源", "OFF", ["OFF", "ON"])}</Grid>
        <Grid container item>{createRow("DAC電源", "OFF", ["OFF", "ON"])}</Grid>
        <Grid container item>{createRow("VEXT", "OFF", ["OFF", "ON"])}</Grid>
      </Grid>
    <Grid container item spacing={3} sx={{ maxWidth: "80%" }}>
      <React.Fragment>
        <Grid item xs={6}>
          {dacBox(1)}
        </Grid>
        <Grid item xs={6}>
          {dacBox(2)}
        </Grid>
      </React.Fragment>
    </Grid>
    <Grid sx={{ maxWidth: "70%" }}>
      {adcBox()}
    </Grid>
  </Box>
);
}
